import React, { useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";

const CheckInFile = ({ Show, Hide, Title, projectData, getEditorProjectData, handleAddNewTab }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [remark, setRemark] = useState("");
  const { studyId } = useParams()

  const checkInCheckoutProjectCode = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to check in this file!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Checkin it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {}
        userData.studyId = studyId;
        userData.projectId = projectData?.projectId
        userData.commonId = projectData?.commonId
        userData.name = projectData?.name
        userData.remark = remark
        userData.type = "checkIn"
        let data = await editorProjectServices.checkInCheckoutProjectCode(userData)
        if (data?.statusCode === 200) {
          let objectId = { ...projectData, checkIn: "yes", version: Number(projectData?.version) + 1, projectName: `${projectData?.path?.split('/')?.[0]}` };
          getEditorProjectData()
          const studyTabs = JSON.parse(localStorage.getItem("studyTabs"));
          if ((studyTabs || [])?.some(item => item.studyTabId === `projectManagement_${projectData?.uniqueId}`)) {
            handleAddNewTab(
              `${projectData?.name}.${projectData?.extension} [${projectData?.path?.split('/')?.[0]}]`,
              "fa-solid fa-database",
              `projectManagement_${projectData?.uniqueId}`,
              objectId
            )
          }
          setRemark("")
          Hide()
        }
      }
    });
    setButtonLoader(false)
  }

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Remark{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setRemark(e.target.value)}
              value={remark}
              as="textarea"
              rows={3}
              className="fontSize12"
              placeholder="Enter Remark"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            disabled={buttonLoader || !remark}
            onClick={checkInCheckoutProjectCode}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Loading...
              </div>
            ) : (
              Title
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default CheckInFile;
